import { fromUnixTime, getUnixTime, parseISO, startOfDay } from 'date-fns';

export const unstringifyBooleans = (obj, booleanKeys) => {
  const objToReturn = { ...obj };
  for (const prop in objToReturn) {
    if (Object.hasOwn(objToReturn, prop)) {
      if (booleanKeys.includes(prop)) {
        objToReturn[prop] = JSON.parse(objToReturn[prop]);
      }
    }
  }
  return objToReturn;
};

export const unNullifyArrays = (obj, arrayKeys) => {
  const objToReturn = { ...obj };
  for (const prop in objToReturn) {
    if (Object.hasOwn(objToReturn, prop)) {
      if (arrayKeys.includes(prop)) {
        objToReturn[prop] ||= [];
      }
    }
  }
  return objToReturn;
};

/** @type {(date?: Date | null) => number | null} */
export const dateToTimestamp = (date) => {
  if (date) {
    return getUnixTime(date);
  } else {
    return null;
  }
};

/** @type {(timestamp?: number) => Date?} */
export const timestampToDate = (timestamp) => {
  if (timestamp) {
    return fromUnixTime(timestamp);
  } else {
    return null;
  }
};

/** @type {(string?: string) => Date?} */
export const stringToDate = (string) => {
  if (string) {
    return startOfDay(parseISO(string));
  } else {
    return null;
  }
};

/** @type {(date?: Date | null) => string | null} */
export const dateToString = (date) => {
  if (date) {
    // Use local date methods to avoid timezone conversion issues
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  } else {
    return null;
  }
};

/** @type {(cents: number) => number} */
export const centsToDollars = (cents) => {
  return cents / 100.0;
};

/** @type {(dollars: number) => number} */
export const dollarsToCents = (dollars) => {
  return dollars * 100;
};

/** @type {(obj: any, fields: string[]) => void} */
export const removeReadOnlyFields = (obj, fields) => {
  fields.forEach((field) => {
    delete obj[field];
  });
};

/** @type {(obj: any, associationNames: string[]) => any} */
export const associationsToIds = (obj, associationNames) => {
  return associationNames.reduce((acc, assocName) => {
    return associationToIds(acc, assocName);
  }, obj);
};

/** @type {(obj: any, associationNames: string[]) => any} */
export const associationsToId = (obj, associationNames) => {
  return associationNames.reduce((acc, assocName) => {
    return associationToId(acc, assocName);
  }, obj);
};

/** @type {(json: any, associationName: string) => any} */
function associationToIds(json, associationName) {
  const associationIds = json[associationName]?.map((a) => a.id) || [];
  const associationKey = `${associationName.slice(0, -1)}_ids`;

  /* eslint-disable-next-line */
  const { [associationName]: _, ...rest } = json;

  // Returning a new object with the association ids and the rest of the properties
  return {
    ...rest,
    [associationKey]: json[associationKey] || associationIds,
  };
}

/** @type {(json: any, associationName: string) => any} */
function associationToId(json, associationName) {
  const associationId = json[associationName]?.id;
  const associationKey = `${associationName}_id`;

  /* eslint-disable-next-line */
  const { [associationName]: _, ...rest } = json;

  // Returning a new object with the association ids and the rest of the properties
  return {
    ...rest,
    [associationKey]: json[associationKey] || associationId,
  };
}
